import { render, staticRenderFns } from "./detailChart.vue?vue&type=template&id=471436d7&scoped=true&"
import script from "./detailChart.vue?vue&type=script&lang=js&"
export * from "./detailChart.vue?vue&type=script&lang=js&"
import style0 from "./detailChart.vue?vue&type=style&index=0&id=471436d7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471436d7",
  null
  
)

export default component.exports